import { render, staticRenderFns } from "./LocateButton.vue?vue&type=template&id=45d664d7&scoped=true&"
import script from "./LocateButton.vue?vue&type=script&lang=js&"
export * from "./LocateButton.vue?vue&type=script&lang=js&"
import style0 from "./LocateButton.vue?vue&type=style&index=0&id=45d664d7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d664d7",
  null
  
)

export default component.exports